import { InitialState, StoreLoadingEnum } from 'src/store/state/types';
import { UserEntitlements } from './types';
import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';

import { RootState } from '../..';
import authUserAPI from './api';
import { createApiError } from 'src/services/api/helper';

/**
 * Initial State
 */

const initialState: InitialState<UserEntitlements | null> = {
  loading: StoreLoadingEnum.idle,
  error: null,
  data: null,
};

/**
 * Async Actions
 */

export const fetchUserEntitlements = createAsyncThunk(
  'authUser/entitlements',
  async (_, thunkApi) => {
    try {
      const response = await authUserAPI.entitlements();
      return { data: { ...response.data } };
    } catch (e: any) {
      return thunkApi.rejectWithValue(createApiError(e));
    }
  },
);

export const entitlementsSlice = createSlice({
  name: 'authUser/entitlements',
  initialState,
  reducers: {
    setEntitlementsData: (state, action: { payload: UserEntitlements }) => {
      state.data = action.payload;
      state.loading = StoreLoadingEnum.succeeded;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserEntitlements.pending, (state) => {
        state.loading = StoreLoadingEnum.pending;
      })
      .addCase(fetchUserEntitlements.fulfilled, (state, action) => {
        state.loading = StoreLoadingEnum.succeeded;
        const { data } = action.payload;
        state.data = data;
      })
      .addCase(fetchUserEntitlements.rejected, (state) => {
        state.loading = StoreLoadingEnum.failed;
      });
  },
});

export const entitlementsSelector = (state: RootState) => state.entitlements;
export const authUserSelector = createSelector(
  entitlementsSelector,
  (state) => state.data?.user ?? null,
);

export const entitlementsDataSelector = (state: RootState) => state.entitlements.data;
